import React, { useEffect, useState } from "react";
import { Modal, Input, Table, Checkbox, Button, Switch, Tooltip, Spin } from "antd";
import { AreaChartOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { columnsK, columnsO, columnsD, columnsST } from "./VerifyStatsCols";
import stat from "../../../assets/img/stat-icon.png";

const { TextArea } = Input;

const CheckboxWithBackground = ({ value, color }) => (
  <div className={color}>
    <Checkbox checked={value} disabled />
  </div>
);

const renderBooleanResult = (value, row, colorClass) => ({
  children: <CheckboxWithBackground value={!!value} color={colorClass} />,
  props: {},
});

const rosterNameByAthleteId = (athletesList) =>
  (athletesList ?? []).reduce((acc, item) => {
    const id = item?.athlete?.id;
    if (id != null) acc[String(id)] = item.athlete;
    return acc;
  }, {});

/** Prefer names on the grade; roster lookup only when names missing and list present. */
const withPlayerNames = (grades = [], athletesList) => {
  const list = athletesList ?? [];
  if (!list.length) return grades ?? [];
  const roster = rosterNameByAthleteId(list);
  return (grades ?? []).map((grade) => {
    if (grade?.first_name || grade?.last_name) return grade;
    const athlete = roster[String(grade?.athlete)];
    if (!athlete) return grade;
    return {
      ...grade,
      first_name: athlete.first_name,
      last_name: athlete.last_name,
    };
  });
};

const PlayerTable = ({ grades, play, athletesList }) => {
  const columns = {
    k: columnsK(play),
    o: columnsO(play),
    d: columnsD(play),
    dt: columnsST(play),
  };

  return (
    <Table
      columns={columns[play?.odk?.toLowerCase()]}
      dataSource={withPlayerNames(grades, athletesList)}
      size="middle"
      pagination={false}
      bordered
    />
  );
};

const VerifyStats = ({
  play,
  playInfoColumns,
  grades,
  athletesList,
  toggleEditorMode,
  editorMode: eMode,
  coachNote,
  playsListLoading = false,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [editorMode, setEditorMode] = useState(false);

  useEffect(() => {
    setEditorMode(eMode);
  }, [eMode]);

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);

  const handleEditorMode = () => {
    if (!editorMode) handleCancel();
    toggleEditorMode();
  };

  const playReportLoading = !play && playsListLoading;

  return (
    <div className="flex">
      <Tooltip title="Play Report">
        <img
          src={stat}
          className="w-[24px] cursor-pointer"
          onClick={() => showModal()}
        />
      </Tooltip>
      {isModalVisible && (
        <Modal
          title={`Play Report`}
          open={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          width={1100}
        >
          {playReportLoading ? (
            <div className="flex justify-center items-center py-16">
              <Spin tip="Loading play report..." />
            </div>
          ) : (
            <>
              <div className="flex justify-between">
                <div
                  className={`${coachNote ? "invisible" : ""} flex items-center`}
                >
                  <div className="mr-[12px]  bg-[#dee2e6] rounded-[8px] h-[25px] ">
                    {editorMode ? (
                      <Switch
                        onChange={handleEditorMode}
                        defaultChecked
                        value={true}
                      />
                    ) : (
                      ""
                    )}
                    {editorMode ? (
                      ""
                    ) : (
                      <Switch onChange={handleEditorMode} value={false} />
                    )}
                  </div>
                  <p className="m-[auto]">Edit Stats</p>
                </div>

                <div className="flex justify-end mb-3">
                  <div className="flex datas-center font-bold">
                    <div className="flex flex-col mr-6 text-center">
                      <span className="text-[8px] text-[#526B84]">Execution</span>
                      <span className="text-[18px] text-[#00B21E]">
                        {(
                          (grades.reduce(
                            (a, b) => a + b?.assignment_executed,
                            0,
                          ) /
                            grades.length) *
                          100
                        ).toFixed(2)}
                        % <br />
                      </span>
                    </div>
                    <div className="flex flex-col text-center mr-2">
                      <span className="text-[8px] text-[#526B84]">Effort</span>
                      <span className="text-[18px] text-[#00B21E]">
                        {(
                          (grades.reduce((a, b) => a + b?.great_effort, 0) /
                            grades.length) *
                          100
                        ).toFixed(2)}
                        % <br />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <Table
                pagination={false}
                columns={playInfoColumns}
                dataSource={[play]}
                bordered
                className="mb-3"
              />

              <PlayerTable
                athletesList={athletesList}
                grades={
                  coachNote
                    ? grades?.filter((grade) => grade?.play === play?.id)
                    : grades
                }
                play={play}
              />
            </>
          )}
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  coachProfile: state?.app?.account?.profile?.data?.details,
});

const mapDispatchToProps = (dispatch) => ({
  addComment: (details) =>
    dispatch(global.redux.action.plays.addComment(details)),
  archiveComment: (details) =>
    dispatch(global.redux.action.plays.archiveComment(details)),
  getCommentsForPlay: (details) =>
    dispatch(global.redux.action.plays.getCommentsForPlay(details)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyStats);
